import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import BarsChart from "../../../../components/BarsChart/BarsChart";

const BoxDistributionAge = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const parsedDataset = data.map(({ age_range, number }) => ({
    range: age_range,
    number: Number(number),
  }));

  return (
    <Box
      sx={{
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <BarsChart
        dataset={parsedDataset}
        yDataKey="number"
        yScaleType="linear"
        xScaleType="band"
        xDataKey="range"
        height={300}
        width={isMobile ? 240 : 350}
        layout="vertical"
        series={[
          {
            dataKey: "number",
            label: "Distribuzione età",
            valueFormatter: (value) => `${value}`,
            color: "rgb(228, 147, 25)",
          },
        ]}
      />
    </Box>
  );
};

export default BoxDistributionAge;
